import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementComplex`;
const prtectedApiUrl=process.env.REACT_APP_Protected_API_URL;


const ApiAmusementComplex = {
  getAmusementComplex: (params) => {
    
    const url = `${baseServiceUrl}`;
    

    return ServiceApi.get(url,{params});
  },
  createAmusementTestimonial: (params) => {
    
    const url = `${prtectedApiUrl}${baseServiceUrl}/createAmusementTestimonial`;
    
    return ServiceApi.post(url,params);
  },
  updateAmusementTestimonialLikeOrDislike: (params) => {
    
    const url = `${prtectedApiUrl}${baseServiceUrl}/updateAmusementTestimonialLikeOrDislike`;
    
    return ServiceApi.put(url,params);
  },
};

export default ApiAmusementComplex;